import { render, staticRenderFns } from "./patronall-robot.vue?vue&type=template&id=7ff7caff&scoped=true&"
import script from "./patronall-robot.js?vue&type=script&lang=js&"
export * from "./patronall-robot.js?vue&type=script&lang=js&"
import style0 from "./patronall-robot.css?vue&type=style&index=0&id=7ff7caff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff7caff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
